export const styles = {
  buttonContainer: {
    overflow: 'auto',
    width: 'fit-content'
  }
};
